module.exports = __webpack_public_path__ + "img/tutorial-f03-01.72b198e3.png";